import { useState, useEffect } from 'react';

const MESSAGE_TYPE = 'contentSize';

export const useContentSize = (isHeightSetFromContent: boolean) => {
	// The initial height is arbitrarily set to 1000
	const [height, setHeight] = useState(1000);

	useEffect(() => {
		if (!isHeightSetFromContent) {
			return;
		}
		const contentSizeHandler = (postMessage: MessageEvent) => {
			const data = postMessage.data;

			if (data.type === MESSAGE_TYPE && data.height) {
				setHeight(data.height);
			}
		};

		window.addEventListener('message', contentSizeHandler);

		return () => {
			window.removeEventListener('message', contentSizeHandler);
		};
	}, [isHeightSetFromContent]);

	return { height };
};
